/* eslint-disable */
import Layout from '@/layout/index.vue';

const routes = {
  // 招聘管理
  RecruitMag: () => import(/* webpackChunkName: "dict" */ '@/views/page/RecruitMag/index')
};

export const recruitMagRoute = [
  {
    path: '/RecruitMag',
    component: Layout,
    redirect: { name: 'RecruitMag' },
    isMenu: true,
    children: [
      {
        path: 'index',
        name: 'RecruitMag',
        component: routes['RecruitMag'],
        meta: { title: '招聘管理', icon: 'menu_zhaopin'}
      }
    ]
  }
];
